/**
 * 地図クリック（青ピン）用の追加項目同期システム
 * PropertySelectionGridと地図クリックポップアップ間で追加項目データを同期するためのユーティリティ
 */

import { createPropertyGridPopupSyncSystem } from "./createSyncSystem";

export const MAP_CLICK_ADDITIONAL_FIELDS_UPDATE_EVENT =
  "updateMapClickAdditionalFields";

const { dispatch, addListener } = createPropertyGridPopupSyncSystem<string>(
  MAP_CLICK_ADDITIONAL_FIELDS_UPDATE_EVENT
);

/**
 * 地図クリックの追加項目更新イベントを発火する
 * @param additionalFields 更新する追加項目（JSON文字列）
 */
export const dispatchMapClickAdditionalFieldsUpdate = (
  additionalFields: string
): void => {
  dispatch(additionalFields);
};

/**
 * 地図クリックの追加項目更新イベントリスナーを追加する
 * @param callback 追加項目が更新された際に呼び出されるコールバック関数
 * @returns クリーンアップ関数
 */
export const addMapClickAdditionalFieldsUpdateListener = (
  callback: (additionalFields: string) => void
): (() => void) => {
  return addListener(callback);
};
